export default "__VITE_ASSET__QsjAgkFU__"